define('app/views/carousels_view',['app/setup'], function (takhfifan) {
  takhfifan.carouselsView = Backbone.View.extend({

    initialize: function () {
      this.$el.find('.carousel-slides li').first().addClass('current');
      this.startRotation();
    },

    startRotation: function () {
      var counter = 0;
      var _this = this;
      setInterval(function () {
        var items = _this.$el.find('.carousel-slides li');
        items[counter].classList.remove('current');
        counter = (counter + 1) % items.length;
        items[counter].classList.add('current');
      }, 5000);
    }
  });
});

